angular.module('app').directive('pgFormGroup', ["$interval", "$timeout", function ($interval, $timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var fieldSelector = 'input, select, textarea';
      var bodyFieldSelector = '.form-group.form-group-default input, .form-group.form-group-default select, .form-group.form-group-default textarea';
      var eF = function () {
        $(this).find(fieldSelector).focus();
      };
      $(element).on('click', eF);
      var bFf = function () {
        $('.form-group.form-group-default').removeClass('focused');
        $(this).parents('.form-group').addClass('focused');
      };
      $('body').on('focus', bodyFieldSelector, bFf);
      var bFb = function () {
        $(this).parents('.form-group').removeClass('focused');
        if ($(this).val()) {
          $(this).closest('.form-group').find('label').addClass('fade');
        } else {
          $(this).closest('.form-group').find('label').removeClass('fade');
        }
      };
      $('body').on('blur', bodyFieldSelector, bFb);
      var fIn = function () {
        $('.form-group.form-group-default').removeClass('focused');
        element.addClass('focused');
      };
      var fOut = function () {
        element.removeClass('focused');
        var hasValue = false;
        element.find(fieldSelector).each(function () {
          if ($(this).val()) hasValue = true;
        });
        var $label = element.find('label');
        if (hasValue) $label.addClass('fade');else $label.removeClass('fade');
      };
      element[0].addEventListener('pg-focus-in', fIn);
      element[0].addEventListener('pg-focus-out', fOut);
      var cancelScopeWatch = scope.$watch($(element).find(fieldSelector).attr("ng-model"), function () {
        if ($(element).find(fieldSelector).val()) {
          $(element).closest('.form-group').find('label').addClass('fade');
        } else {
          $(element).closest('.form-group').find('label').removeClass('fade');
        }
      });
      $(element).find('.checkbox, .radio').hover(function () {
        $(this).parents('.form-group').addClass('focused');
      }, function () {
        $(this).parents('.form-group').removeClass('focused');
      });
      scope.$on("$destroy", function () {
        cancelScopeWatch();
        $(element).off("click", eF);
        $('body').off('focus', bodyFieldSelector, bFf);
        $('body').off('blur', bodyFieldSelector, bFb);
        element[0].removeEventListener('pg-focus-in', fIn);
        element[0].removeEventListener('pg-focus-out', fOut);
      });
    }
  };
}]);